export const CLAIMS_PRACTICE_CAR_LIST: string = 'practice_car';
export const CLAIMS_PRACTICE_CAR_DETAILS: string = 'details';
export const CLAIMS_PRACTICE_CAR_DETAILS_HISTORICAL: string = 'historical';
export const CLAIMS_NEW_PRACTICE_CAR: string = 'new';
export const CLAIMS_NEW_PRACTICE_CAR_FORM: string = 'form';

